<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title inline">Monthly Summary</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label class="form-label">Year</label>
            <select class="form-control custom-select" v-model="form.year">
              <option value>-Select-</option>
              <option v-for="(item, index) in years" :key="index" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <label class="form-label">Month</label>
            <select class="form-control custom-select" v-model="form.month">
              <option value>-Select-</option>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label">People</label>
            <v-select
              taggable
              label="name"
              :options="valuers"
              multiple
              v-model="form.valuer"
              class="custom-select2"
            ></v-select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="form-label">&nbsp;</label>
            <button
              type="button"
              @click="filterReport"
              class="btn btn-primary"
              :disabled="form.year == '' || form.month == ''"
            >
              Filter
            </button>
          </div>
        </div>
      </div>
      <span v-if="report.ytd != ''">
        <div class="row table-tools">
          <div class="col-md-12">
            <div class="download-container">
              <a href="#" @click.prevent="export_to_csv">
                <i class="fa fa-download" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-striped" ref="monthlySummaryTable">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col" class="text-right">
                      Billed Cases
                      <br />
                      ({{ months[parseInt(this.form.month) - 1] }}
                      {{ this.form.year }})
                    </th>
                    <th scope="col" class="text-right">
                      Billed Cases
                      <br />
                      (YTD {{ this.form.year }})
                    </th>
                    <th scope="col" class="text-right">
                      Invoiced Sales
                      <br />
                      ({{ months[parseInt(this.form.month) - 1] }}
                      {{ this.form.year }})
                    </th>
                    <th scope="col" class="text-right">
                      Invoiced Sales
                      <br />
                      (YTD {{ this.form.year }})
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in report.cases" :key="index">
                    <td>
                      <a
                        href="javascript:;"
                        @click.prevent="
                          loadIndividualReport(item.bring_in_user_id)
                        "
                        v-if="item.bring_in_user_id != null"
                      >
                        {{ item.name }}
                      </a>
                    </td>

                    <td class="text-right">
                      <span v-if="item.cases != null">{{ item.cases }}</span>
                      <span v-else>0</span>
                    </td>
                    <td class="text-right">{{ item.ytd }}</td>
                    <td class="text-right">{{ item.sales || 0 | currency }}</td>
                    <td class="text-right">
                      {{ item.ytdsale || 0 | currency }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text-bold">Total</td>
                    <td class="text-bold text-right">
                      {{ report.casesTotal.cases || 0 }}
                    </td>
                    <td class="text-bold text-right">
                      {{ report.casesTotal.ytd || 0 }}
                    </td>
                    <td class="text-bold text-right">
                      {{ report.casesTotal.sales || 0 | currency }}
                    </td>
                    <td class="text-bold text-right">
                      {{ report.casesTotal.ytdsale || 0 | currency }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">Unbilled Type</th>
                    <th scope="col" class="text-right">
                      Unbilled Cases <br />({{
                        months[parseInt(this.form.month) - 1]
                      }}
                      {{ this.form.year }})
                    </th>
                    <th scope="col" class="text-right">
                      Unbilled Cases <br />(YTD {{ this.form.year }})
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in report.report" :key="index">
                    <td>{{ item.report_type }}</td>
                    <td class="text-right text-right">
                      <span v-if="item.cases != null">{{ item.cases }}</span>
                      <span v-else>0</span>
                    </td>
                    <td class="text-right text-right">{{ item.ytd }}</td>
                  </tr>

                  <tr v-if="report.reportTotal != null">
                    <td class="text-bold text-right">Total</td>
                    <td class="text-bold text-right">
                      <span v-if="report.reportTotal.cases != null">
                        {{ report.reportTotal.cases }}
                      </span>
                      <span v-else>0</span>
                    </td>
                    <td class="text-bold text-right">
                      <span v-if="report.reportTotal.ytd != null">
                        {{ report.reportTotal.ytd }}
                      </span>
                      <span v-else>0</span>
                    </td>
                  </tr>
                  <tr v-else>
                    <td colspan="3" class="text-center">No records found!</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      valuers: [],
      years: [],
      form: {
        year: "",
        month: "",
        valuer: "",
      },
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      report: { ytd: "" },
    };
  },
  methods: {
    loadIndividualReport(id) {
      this.$router.push({
        name: "individual-monthly-summary",
        query: {
          id: id,
          year: this.form.year,
          month: this.form.month,
        },
      });
    },
    download_csv(csv, filename) {
      var csvFile;
      var downloadLink;
      csvFile = new Blob([csv], { type: "text/csv" });
      downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },

    export_to_csv() {
      var csv = [];
      var rows = this.$refs.monthlySummaryTable.querySelectorAll("tr");
      for (var i = 0; i < rows.length; i++) {
        var row = [],
          cols = rows[i].querySelectorAll("td, th");
        for (var j = 0; j < cols.length; j++) {
          row.push(cols[j].innerText.replace(/(\r\n|\n|\r)/gm, ""));
        }
        csv.push('"' + row.join(",") + '"');
      }
      this.download_csv(csv.join("\n"), "Monthly-Summary.csv");
    },
    filterReport() {
      let data = { year: this.form.year, month: this.form.month };

      if (this.form.valuer != "") {
        data.valuer = [];
        this.form.valuer.forEach((item) => {
          data.valuer.push(item.id);
        });
      }
      this.$parent.$refs.progressModal.show();
      this.$http.post(this.rootUrl + "report/monthly-summary", data).then(
        (res) => {
          this.refreshToken(res);
          this.$parent.$refs.progressModal.hide();
          // console.log(JSON.parse(JSON.stringify(res.data)));
          this.report = res.data;
          if (this.report.cases.length == 0 && this.report.report.length == 0) {
            this.$snotify.error(
              "No Data for current filter",
              "Monthly Summary",
              {
                timeout: 4000,
                showProgressBar: false,
                position: "rightTop",
              }
            );
          }
        },
        (err) => {
          if (typeof err.response !== "undefined") {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
          } else {
            console.log(JSON.parse(JSON.stringify(err)));
          }
        }
      );
    },
  },
  mounted() {
    this.$http.get(this.rootUrl + "user/fetch?role=all", this.corsConfig).then(
      (res) => {
        this.refreshToken(res);
        this.valuers = res.data;
        // this.streetNames = _.map(this.streetNames, "street_name");
        // this.streetNames = _.uniq(_.compact(this.streetNames));
      },
      (err) => {
        this.$snotify.error(err.response.data.message, "Valuation", {
          timeout: 4000,
          showProgressBar: false,
          position: "rightTop",
        });
      }
    );

    this.$http.get(this.rootUrl + "report/years", this.corsConfig).then(
      (res) => {
        this.refreshToken(res);
        this.years = res.data.years;
        //this.months = res.data.months;
      },
      (err) => {
        if (typeof err.response !== "undefined") {
          this.$snotify.error(err.response.data.message, "Valuation", {
            timeout: 4000,
            showProgressBar: false,
            position: "rightTop",
          });
        } else {
          console.log(JSON.parse(JSON.stringify(err)));
        }
      }
    );
  },
};
</script>
